import { render, staticRenderFns } from "./OushiA3.vue?vue&type=template&id=22dcb340&scoped=true&"
import script from "./OushiA3.vue?vue&type=script&lang=js&"
export * from "./OushiA3.vue?vue&type=script&lang=js&"
import style0 from "./OushiA3.vue?vue&type=style&index=0&id=22dcb340&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dcb340",
  null
  
)

export default component.exports